import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

const RowExpansionTemplate = ({ data, onRowCopy, handleRowEdit, onRowDelete, issueClass }) => {
  return (
    <DataTable value={data.entries} stripedRows className="expanded-table">
      <Column field="user" header="User" />
      <Column
        header="Activity"
        body={(entry) => {
          const dynamicClass = issueClass(entry);
          return (
            <div className="activity-btn-wrapper">
              <div className={`activity-indicator ${dynamicClass}`}></div>
            </div>
          );
        }}
        style={{ width: '2rem' }}
      />
      <Column field="client" header="Client" />
      <Column field="esp" header="Esp" />
      <Column field="country" header="Country" />
      <Column field="module_type" header="Module type" />
      <Column field="module" header="Module" />
      <Column field="stage" header="Stage" />
      <Column field="task" header="Task" />
      <Column field="hours" header="Hours" />
      <Column field="comment" header="Comment" />
      <Column
        body={(subRowData) => (
          <div className="row-btn-wrapper">
            <Button
              icon="pi pi-copy"
              rounded
              text
              severity="info"
              onClick={() => onRowCopy(subRowData)}
              aria-label="Copy"
            />
            <Button
              icon="pi pi-pencil"
              rounded
              text
              severity="warning"
              onClick={() => handleRowEdit(subRowData)}
              aria-label="Pencil"
            />
            <Button
              icon="pi pi-times"
              rounded
              text
              severity="danger"
              onClick={() => onRowDelete(subRowData._id)}
              aria-label="Cancel"
            />
          </div>
        )}
      />
    </DataTable>
  );
};

export default RowExpansionTemplate;
